export const SEND_MAIL_ERRORS = `
  mutation sendMailErrosContent(
    $userId: String, 
    $userRole: String, 
    $userSites: String, 
    $userEmail: String, 
    $userName: String,
    $location: String,
    $os: String,
    $osVersion: String,
    $browserVersion: String,
    $browserName: String,
    $error: String,
    $errorInfo: String
  ) {
      sendMailErrosContent(input: { 
        userId: $userId, 
        userRole: $userRole, 
        userSites: $userSites, 
        userEmail: $userEmail, 
        userName: $userName,
        location: $location,
        os: $os,
        osVersion: $osVersion,
        browserVersion: $browserVersion,
        browserName: $browserName,
        error: $error,
        errorInfo: $errorInfo     
      }) {
      userId, 
      error,
      errorInfo
    }  
  }
`;
